import axios from 'axios'

const ENDPOINT = 'unitwidget'

export default {
  get_process_depending_users: async (sitePath, data) => {
    // data: process_id, permission_id
    const url = `${sitePath}/${ENDPOINT}/get_process_depending_users/?process_id=${data.process_id}&permission_id=${data.permission_id}`;
    return await axios.get(url, data);
  },
}
